export default {"src":"/_next/static/media/circleCheckmark_24.7ddd7c17.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};